import { c as _c } from "react/compiler-runtime";
import { CSSProperties, ReactElement, memo } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import { generateStyleTag } from './generatePlaceholderStyle';
import styles from './placeholder.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface HeightSinceWidthEntry {
  readonly sinceWidth: number;
  readonly height: number;
}
export type HeightSinceWidth = HeightSinceWidthEntry[];
interface CssHeightSinceWidthEntry {
  readonly sinceWidth: number;
  readonly height: number | string;
}
type CssHeightSinceWidth = CssHeightSinceWidthEntry[];
export interface Props {
  readonly id: string;
  readonly ratio?: number;
  readonly heightSinceWidth?: CssHeightSinceWidth;
  readonly error?: boolean;
}
function PlaceholderComponent(t0) {
  const $ = _c(25);
  const {
    id,
    error,
    ratio,
    heightSinceWidth
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("placeholder");
  let cssId;
  let hasError;
  let isUsingRatio;
  let style;
  let styleTag;
  if ($[0] !== error || $[1] !== heightSinceWidth || $[2] !== id || $[3] !== ratio) {
    cssId = id.replaceAll(":", "");
    hasError = error === true;
    style = undefined;
    isUsingRatio = false;
    styleTag = null;
    if (ratio !== undefined) {
      const t1 = ratio * 100 + "%";
      let t2;
      if ($[9] !== t1) {
        t2 = {
          paddingTop: t1
        };
        $[9] = t1;
        $[10] = t2;
      } else {
        t2 = $[10];
      }
      style = t2;
      isUsingRatio = true;
    } else {
      if (heightSinceWidth === undefined) {
        throw new Error("Ratio or heightSinceWidth must be provided");
      }
      styleTag = generateStyleTag(cssId, heightSinceWidth);
    }
    $[0] = error;
    $[1] = heightSinceWidth;
    $[2] = id;
    $[3] = ratio;
    $[4] = cssId;
    $[5] = hasError;
    $[6] = isUsingRatio;
    $[7] = style;
    $[8] = styleTag;
  } else {
    cssId = $[4];
    hasError = $[5];
    isUsingRatio = $[6];
    style = $[7];
    styleTag = $[8];
  }
  let t1;
  if ($[11] !== hasError || $[12] !== isUsingRatio) {
    t1 = classNames(styles.placeholder, {
      [styles["placeholder--using-ratio"]]: isUsingRatio,
      [styles["placeholder--error"]]: hasError
    });
    $[11] = hasError;
    $[12] = isUsingRatio;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const classes = t1;
  let t2;
  if ($[14] !== formatMessage || $[15] !== hasError) {
    t2 = hasError && <div className={styles["placeholder__error-msg"]}>{formatMessage("errorMsg")}</div>;
    $[14] = formatMessage;
    $[15] = hasError;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== classes || $[18] !== cssId || $[19] !== style || $[20] !== t2) {
    t3 = <div id={cssId} className={classes} role="tooltip" style={style} aria-label="placeholder">{t2}</div>;
    $[17] = classes;
    $[18] = cssId;
    $[19] = style;
    $[20] = t2;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== styleTag || $[23] !== t3) {
    t4 = <>{styleTag}{t3}</>;
    $[22] = styleTag;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
}
export default memo(PlaceholderComponent);